import { render, staticRenderFns } from "./opening-hours-tile-content.vue?vue&type=template&id=2a6ab013"
import script from "./opening-hours-tile-content.vue?vue&type=script&lang=js"
export * from "./opening-hours-tile-content.vue?vue&type=script&lang=js"
import style0 from "./opening-hours-tile-content.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports